import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core"
import { AuthService } from "src/app/services/auth.service"
import { environment } from "src/environments/environment"
import { BaseService } from "../../../../services/base.service"

@Component({
	selector: "app-catalog-p2p",
	templateUrl: "./catalog-p2p.component.html",
	styleUrls: ["./catalog-p2p.component.scss"]
})
export class CatalogP2pComponent implements OnInit {
	@Input() isFromModal: boolean
	@Input() buildingType: string
	@Output() checkBea = new EventEmitter()
	services: any
	beaValues: any
	belValues: any
	bea_values1g: any
	bea_values10g: any
	bel_values1g: any
	bel_values10g: any
	public userData: any
	public assets_version = environment.ASSETS_VERSION

	constructor(
		private baseService: BaseService,
		public authService: AuthService
	) {}

	ngOnInit(): void {
		this.authService.getUserData().subscribe(res => {
			this.userData = res
		})
		this.baseService.getServicesP2P().subscribe(res => {
			this.services = res
		})
	}

	returnRange(value) {
		if (value) {
			let number
			value = Number(value)
			if (value !== 10) {
				number = value - 1
			} else {
				number = 5
			}
			return number + "-" + value
		}
	}
}
